export function navPhase(groupCount, loading) {
    // Groups already on screen win over a flag. A background refetch of
    // `/auth/me` must not replace navigation the reader is using with a status
    // line — the sweep's `stale` rule, applied to the rail.
    if (groupCount > 0)
        return 'ready';
    return loading ? 'checking' : 'none';
}
//# sourceMappingURL=navPhase.js.map